export default __webpack_public_path__ + "static/media/river-people-health-center.3c251a4d.jpg";